import { Store } from 'src/store/index';

const getEditorMode = (store: Store) => store.app.editorMode;

export default getEditorMode;
